import { render, staticRenderFns } from "./productcomment.vue?vue&type=template&id=52f42dbe&"
import script from "./productcomment.vue?vue&type=script&lang=js&"
export * from "./productcomment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports